<template>
  <!--begin::Notification bar-->
  <div class="notification-bar" aria-live="polite" aria-atomic="false">
    <TransitionGroup
      tag="div"
      enter-active-class="animate__animated animate__fadeInRight animate__faster"
      leave-active-class="animate__animated animate__fadeOutRight animate__faster"
      move-class="notification-bar-move"
    >
      <div
        v-for="item in notificationBar.notifications"
        :key="item.id"
        :class="`notification-bar-toast d-flex align-items-start bg-light-${colorByType[item.type]} border border-${colorByType[item.type]} border-dashed rounded shadow-sm p-5 mb-3`"
        role="alert"
        @mouseenter="notificationBar.pause(item.id)"
        @mouseleave="notificationBar.resume(item.id)"
      >
        <!--begin::Icon-->
        <i
          :class="`bi ${iconByType[item.type]} fs-2 text-${colorByType[item.type]} me-4 mt-1`"
        ></i>
        <!--end::Icon-->

        <!--begin::Content-->
        <div class="flex-grow-1 me-3">
          <div v-if="item.title" class="fw-bolder text-gray-900 fs-6">
            {{ item.title }}
          </div>
          <div class="text-gray-700 fs-7">{{ item.message }}</div>
          <router-link
            v-if="item.action"
            :to="item.action.to"
            :class="`btn btn-sm btn-light-${colorByType[item.type]} mt-2`"
            @click="notificationBar.dismiss(item.id)"
          >
            {{ item.action.label }}
          </router-link>
        </div>
        <!--end::Content-->

        <!--begin::Close-->
        <button
          type="button"
          class="btn btn-icon btn-sm btn-active-light ms-auto"
          aria-label="Cerrar notificación"
          @click="notificationBar.dismiss(item.id)"
        >
          <i class="bi bi-x fs-3"></i>
        </button>
        <!--end::Close-->
      </div>
    </TransitionGroup>
  </div>
  <!--end::Notification bar-->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  useNotificationBar,
  NotificationBarType,
} from "@/core/composables/useNotificationBar";

export default defineComponent({
  name: "notification-bar",
  setup() {
    const notificationBar = useNotificationBar();

    const colorByType: Record<NotificationBarType, string> = {
      success: "success",
      error: "danger",
      warning: "warning",
      info: "info",
    };

    const iconByType: Record<NotificationBarType, string> = {
      success: "bi-check-circle-fill",
      error: "bi-x-circle-fill",
      warning: "bi-exclamation-triangle-fill",
      info: "bi-info-circle-fill",
    };

    return {
      notificationBar,
      colorByType,
      iconByType,
    };
  },
});
</script>

<style scoped>
.notification-bar {
  position: fixed;
  top: calc(var(--kt-app-header-height, 70px) + 15px);
  right: 20px;
  z-index: 1090;
  width: 350px;
  max-width: calc(100vw - 40px);
  pointer-events: none;
}

.notification-bar-toast {
  pointer-events: auto;
}

.notification-bar-move {
  transition: transform 0.3s ease;
}
</style>
